import ApiClient from '../ApiClient';

class WhatsappQrChannel extends ApiClient {
  constructor() {
    super('whatsapp_qr_instances', { accountScoped: true });
  }
}

export default new WhatsappQrChannel();
